/* Scoped read-more controls survive section replacement and font/layout changes. */
if (!customElements.get('fr-read-more')) {
  customElements.define('fr-read-more', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-read-more-btn]');
      this.label = this.querySelector('[data-read-more-text]');
      this.content = this.querySelector('.rich-text__text-content');
      if (!this.button || !this.label || !this.content) return;
      this.moreText = this.button.dataset.readMoreText;
      this.onClick = () => {
        const expanded = !this.classList.contains('is-expanded');
        this.classList.toggle('is-expanded', expanded);
        this.classList.toggle('is-truncated', !expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.label.textContent = expanded ? this.button.dataset.readLessText : this.moreText;
        this.refresh();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new ResizeObserver(() => this.refresh());
      this.observer.observe(this.content);
      this.refresh();
    }
    refresh() {
      // Expanded content must retain its collapse button, even after a resize.
      this.button.hidden = !this.classList.contains('is-expanded') &&
        this.content.scrollHeight <= this.content.clientHeight + 1;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
